import type { ComponentPropsWithoutRef } from "react";
import { LinkProps } from "@tanstack/react-router";

type TanStackLinkProps = Omit<ComponentPropsWithoutRef<"a">, "href"> & {
  href: LinkProps["to"] | string;
};

export default function Link({ href, ...props }: TanStackLinkProps) {
  return <a href={href as string} {...props} />;
}
